import React from "react";
import { useIntl, defineMessages } from "react-intl";

import { useActionStyles } from "../mainHeader";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "../../common/icons/helpIcon";

const messages = defineMessages({
    helpTooltip: {
        id: "main-header.help-tooltip",
        defaultMessage: "Help",
        description: "Help main header toottip",
    },
});

export const Help = (props) => {
    const intl = useIntl();
    const classes = useActionStyles();

    return (
        <IconButton aria-describedby="context-help" className={classes.menuButton}>
            <HelpIcon color="white" title={intl.formatMessage(messages.helpTooltip)} />
        </IconButton>
    );
};

export default Help;
